module.exports = __webpack_public_path__ + "img/pause-circle-fill.a247effe.svg";